import { ComponentType, StageComponent } from "../model/Component.model";

export type StylePredefined = {
  label: string;
  style: string;
};

export const componentStyles: Record<ComponentType, StylePredefined[]> = {
  [ComponentType.Label]: [
    { label: "Small Label", style: "label-small" },
    { label: "Medium Label", style: "label-medium" },
    { label: "Large Label", style: "label-large" },
    { label: "H1 Label", style: "label-h1" },
    { label: "H2 Label", style: "label-h2" },
    { label: "H3 Label", style: "label-h3" },
    { label: "H4 Label", style: "label-h4" },
    { label: "H5 Label", style: "label-h5" },
    { label: "H6 Label", style: "label-h6" },
  ],
  [ComponentType.Checkbox]: [{ label: "Checkbox Element", style: "check1" }],
  [ComponentType.Input]: [
    { label: "Small Input Box", style: "input-small" },
    { label: "Medium Input Box", style: "input-medium" },
    { label: "Large Input Box", style: "input-large" },
  ],
  [ComponentType.Button]: [
    { label: "Small Button", style: "button-small" },
    { label: "Medium Button", style: "button-medium" },
    { label: "Large Button", style: "button-large" },
  ],
  [ComponentType.Line]: [
    { label: "Small Line", style: "line-small" },
    { label: "Medium Line", style: "line-medium" },
    { label: "Large Line", style: "line-large" },
  ],
  [ComponentType.ComboBox]: [
    { label: "Small Dropdown", style: "combobox-small" },
    { label: "Medium Dropdown", style: "combobox-medium" },
    { label: "Large Dropdown", style: "combobox-large" },
  ],
  [ComponentType.Radio]: [{ label: "Radio Element", style: "radio1" }],
  [ComponentType.Image]: [
    { label: "Small Image", style: "image-small" },
    { label: "Medium Image", style: "image-medium" },
    { label: "Large Image", style: "image-large" },
  ],
  [ComponentType.Anchor]: [
    { label: "Small Anchor Tag", style: "anchor-small" },
    { label: "Medium Anchor Tag", style: "anchor-medium" },
    { label: "Large Anchor Tag", style: "anchor-large" },
  ],
};

export const componentDefaults: StageComponent = {
  [ComponentType.Label]: {
    inner_text: "label",
    type: ComponentType.Label,
    width: 200,
    height: 24,
    fontSize: "12",
    style: "label-small",
    fontWeight: "400",
  },
  [ComponentType.Checkbox]: {
    inner_text: "Check",
    type: ComponentType.Checkbox,
    width: 200,
    height: 24,
    style: "check1",
  },
  [ComponentType.Input]: {
    type: ComponentType.Input,
    inner_text: "Input",
    width: 200,
    height: 24,
  },
  [ComponentType.Button]: {
    type: ComponentType.Button,
    inner_text: "Button",
    fontFamily: "Arial",
    fontSize: "12",
    textAlign: "center",
    width: 75,
    height: 30,
    style: "button-small",
  },
  [ComponentType.Line]: {
    type: ComponentType.Line,
    inner_text: null,
    width: 75,
    height: 30,
    borderStyle: "dashed",
    size: 1,
    style: "line-small",
  },
  [ComponentType.ComboBox]: {
    type: ComponentType.ComboBox,
    inner_text: null,
    fontFamily: "Arial",
    fontSize: "12",
    width: 176,
    height: 30,
    options: ["option 1", "option 2"],
    style: "combobox-small",
  },
  [ComponentType.Radio]: {
    type: ComponentType.Radio,
    inner_text: null,
    width: 176,
    height: 50,
    style: "radio1",
    choices: [
      { id: 1, selected: true, name: "Choice 1" },
      { id: 2, selected: false, name: "Choice 2" },
    ],
  },
  [ComponentType.Image]: {
    type: ComponentType.Image,
    inner_text: null,
    style: "image-small",
    width: 100,
    height: 67,
    src: "/admin/assets/images/Image.svg",
  },
  [ComponentType.Anchor]: {
    type: ComponentType.Anchor,
    inner_text: "Link",
    style: "anchor-small",
    url: "https://www.google.com/",
    width: 75,
    height: 30,
  },
};
